var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"bg-green f14 light padding border-radius-5 hand",class:_vm.$isMobile ? 'block' : 'inline-block',on:{"click":_vm.toUrl}},[_c('i',{staticClass:"margin-right",class:_vm.leftIcon}),_vm._v(" 附件："+_vm._s(_vm.filename)+" "),_c('i',{staticClass:"margin-left",class:_vm.rightIcon,attrs:{"aria-hidden":"true"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }